import { defaultMetisProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/metis/default-constants';

export const NET_SWAP_CONTRACT_ADDRESS = '0x1E876cCe41B7b844FDe09E38Fa1cf00f213bFf56';

export const NET_SWAP_PROVIDER_CONFIGURATION = defaultMetisProviderConfiguration;
